(() => {
  const sections = document.querySelectorAll('[data-video-section]');
  if (!sections.length) return;

  const flashIcon = (button, state) => {
    button.dataset.state = state;
    button.classList.add('is-visible');
    button.classList.remove('is-hidden');
    clearTimeout(button._hideTimer);
    button._hideTimer = setTimeout(() => {
      button.classList.remove('is-visible');
    }, 700);
  };

  sections.forEach((section) => {
    const container = section.querySelector('[data-video-container]');
    const video = container ? container.querySelector('video') : null;
    const control = section.querySelector('[data-video-control]');
    const poster = section.querySelector('.sas-video__poster--overlay');

    if (!video || !control) return;

    const playbackMode = section.dataset.playback;
    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';

    video.muted = true;
    video.loop = playbackMode === 'autoplay' && loop;
    control.dataset.state = 'play';
    control.classList.add('is-visible');

    if (playbackMode === 'autoplay' && autoplay) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }

    requestAnimationFrame(() => {
      const track = document.createElement('track');
      track.kind = 'captions';
      track.srclang = 'en';
      track.label = 'English';
      track.src = container.dataset.captionsSrc || '';
      video.appendChild(track);
    });

    let hasInteracted = false;

    const toggle = () => {
      if (!hasInteracted && !video.paused) {
        video.muted = false;
        hasInteracted = true;
        if (poster) {
          poster.classList.add('is-hidden');
        }
        flashIcon(control, 'play');
        return;
      }

      if (video.paused) {
        if (!hasInteracted) {
          video.muted = true;
        }
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              if (!hasInteracted) {
                video.muted = false;
                hasInteracted = true;
                if (poster) {
                  poster.classList.add('is-hidden');
                }
              }
            })
            .catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
        }
      } else {
        video.pause();
      }
    };

    control.addEventListener('click', (event) => {
      event.preventDefault();
      toggle();
    });

    container.addEventListener('click', (event) => {
      if (event.target.closest('[data-video-control]')) return;
      toggle();
    });

    video.addEventListener('playing', () => {
      if (hasInteracted) {
        flashIcon(control, 'play');
      }
    });

    video.addEventListener('pause', () => {
      if (hasInteracted) {
        flashIcon(control, 'pause');
      }
    });
  });
})();
